import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import { Footer, TrustpilotSimple } from '.';
import { Newsletter, Cta, RecentBlogPosts } from '../components';

const Layout = ({ children, paddingBottom = '' }) => {
    return (
        <>
            <Navbar />
            <main>
                <div className={`${paddingBottom}`}>
                    {children}
                </div>
            </main>
            <Footer />
        </>
    );
};

const ServicesLayout = ({ children }) => {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    const TrustpilotCarousel = React.lazy(() => import('../components/TrustpilotCarousel'));

    return (
        <>
            <Navbar />
            <main>
                {children}
                <Cta />
                <RecentBlogPosts />
                {isClient && (
                    <React.Suspense fallback={<div>Loading...</div>}>
                        <TrustpilotCarousel />
                    </React.Suspense>
                )}
                <Newsletter />
            </main>
            <Footer />
        </>
    );
};

const SeminarLayout = ({ children, paddingBottom = '' }) => {
    return (
        <>
            <Navbar />
            <main>
                <div className={`${paddingBottom}`}>
                    {children}
                </div>
                <TrustpilotSimple />
                <RecentBlogPosts />
            </main>
            <Footer />
        </>
    );
};

export { Layout, ServicesLayout, SeminarLayout };